import cleanedFilename from '~/util/cleanedFilename';

export default {
  NAME: `${cleanedFilename(__filename)}-name`,
  EMAIL: `${cleanedFilename(__filename)}-email`,
  ROLE: `${cleanedFilename(__filename)}-role`,
  ACTION: `${cleanedFilename(__filename)}-action`,
};
